import { useContext } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
// Our Components
import { AuthContext } from 'context/auth-context';
// Utils and Helpers
import { CARD_TYPE, GIFT_CARD_CATEGORY } from 'helpers/constants';
// Assets
import physicalCardBackside from 'assets/cardsSection/cardBackgroud.svg';
import virtualCardBackside from 'assets/createCards/virtualCardBackside.png';
import './OrderingCard.css';

const OrderingCard = ({ card, cardholder }) => {
    const { businessInfo } = useContext(AuthContext);

    const getLoaderText = () => {
        const cardLabel = card.label === GIFT_CARD_CATEGORY ? card.label : 'Card';
        if (card.id) return `Updating ${cardLabel}`;
        if (card.type === CARD_TYPE.VIRTUAL) return `Creating ${cardLabel}`;
        if (card.type === CARD_TYPE.PHYSICAL) return `Ordering ${cardLabel}`;
    };
    return (
        <Box className="request-ordering-card" sx={{ width: '100%' }}>
            <Box className="request-ordering-card__info">
                <Box>
                    <Box className="request-card__card-image-container" position="relative" marginBottom="39px">
                        <img
                            className="request-card__card-image"
                            src={card.type === CARD_TYPE.VIRTUAL ? virtualCardBackside : physicalCardBackside}
                            alt="virtual card"
                        />
                        <Typography component="div" className="request-card__card-secret request-card__card-number">
                            **** **** **** ****
                        </Typography>
                        <Typography component="div" className="request-card__card-secret request-card__card-expiration">
                            ****
                        </Typography>
                        <Typography component="div" className="request-card__card-secret request-card__card-cvv">
                            ***
                        </Typography>

                        <Typography
                            component="div"
                            className="request-card__card-backside-cardholder-name embossing-ellipsis"
                            sx={{
                                color: `${card.type === CARD_TYPE.VIRTUAL ? 'var(--white-color)' : 'var(--main-color)'}`
                            }}>
                            {`${cardholder?.first_name} ${cardholder?.last_name}`}
                        </Typography>
                        <Typography
                            component="div"
                            className="request-card__card-backside-cardholder-company embossing-ellipsis"
                            sx={{
                                color: `${card.type === CARD_TYPE.VIRTUAL ? 'var(--white-color)' : 'var(--main-color)'}`
                            }}>
                            {businessInfo.legal_name}
                        </Typography>
                    </Box>
                    <Box className="request-ordering-card__title" sx={{ marginBottom: '20px', width: '200px' }}>
                        {getLoaderText()}
                    </Box>
                    <Box textAlign="center">
                        <CircularProgress />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default OrderingCard;
